'use strict';

module.exports = require('react-transition-group').CSSTransitionGroup;
